export default {
  global: {
    name: 'Nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    tracking: 'Seguimiento | Seguimientos',
    request: 'Solicitud | Solicitudes',
    // dashboard: 'Dashboard',
    shipmentNumber: 'NUMERO DE EMBARQUES',
    totalInvoiceCost: 'COSTO TOTAL DE FACTURA',
    freightCost: 'COSTOS POR FLETE',
    accesorialCost: 'COSTOS POR ACCESORIALES',
    taxesCost: 'COSTOS POR IMPUESTOS',
    fuelCost: 'CUESTOS POR COMBUSTIBLE',
    packages: 'BULTOS',
    lbs: 'LIBRAS',
    miles: 'MILLAS',
    value: 'VALOR DECLARADO',
    transitTime: 'TIEMPO DE TRANSITO',
    loadHours: 'HORAS AL CARGAR',
    unloadHours: 'HORAS AL DESCARGAR',
    origin: 'Origen',
    destination: 'Destino',
    updated: 'Actualizado',
    client_id: 'ID Cliente',
    national: 'Nacional',
    international: 'Internacional',
    company: 'Empresa',
    metric: 'Métrico',
    english: 'Inglés',
    weight: 'Peso',
    length: 'Largo',
    width: 'Ancho',
    height: 'Alto',
    description: 'Descripción',
    priority: 'Prioridad',
    notes: 'Observaciones',
    country: 'País',
    comment: 'Comentario | Comentarios',
    package: 'Bulto | Bultos',
    dimensions: 'Dimensiones',
    price: 'Precio',
    add: 'Agregar',
    menu: 'Menú',
    device: 'Dispositivo | Dispositivos',
    logout: 'Cerrar sesión',
    cancel: 'Cancelar',
    connect: 'Conectar',
    rename: 'Renombrar',
    remove: 'Eliminar',
    save: 'Guardar',
    status: 'Estatus',
    date: 'Fecha',
    detail: 'Detalle',
    routes: 'Rutas',
    departure_date: 'Fecha de salida',
    driver: 'Chofer',
    in_progress: 'En curso',
    completed: 'Completado',
    distance_traveled: 'Distancia recorrida',
    no_routes: 'No hay rutas registradas.',
    intersection: 'Intersección {label}',
    activity: 'Actividad',
    document: 'Documento | Documentos',
    internal: 'Interno',
    emergency: 'Emergencia',
    photo: 'Foto | Fotos',
    audio: 'Audio | Audios',
    home: 'Inicio',
    notification: 'Notificación | Notificaciones',
    accept: 'Aceptar',
    language: 'Idioma',
    close: 'Cerrar',
    requested_by: 'Solicitado por',
    customer: 'Cliente',
    type: 'Tipo',
    direct: 'Directo',
    trailer: 'Tráiler',
    commodities: 'Materias primas',
    importation: 'Importación',
    quantity: 'Cantidad',
    code: 'Código',
    no_results: 'Sin resultados',
    message_no_results:
      'No se encontraron resultados disponibles con esos filtros de busqueda.',
    lbl_country: 'País'
  },
  resetPassword: {
    title: 'Crea una nueva contraseña',
    description:
      'Tu nueva contraseña debe de ser diferente a cualquiera usada anteriormente ',
    lblBtn: 'Cambiar contraseñar',
    messageNullToken: 'No existe token para reestablecer contraseña.'
  },
  dashboard: {
    title: 'Dashboard',
    info: 'La información fue calculada con base en los datos registrados. Para obtener resultados más precisos, por favor complete todos los campos correspondientes.',
    search: 'Buscar',
    filters: {
      title: 'Filtros',
      project: 'Proyecto',
      client: 'Cliente',
      platforms: 'Plataforma',
      date: 'Fecha',
      period: 'Periodo',
      select: 'Seleccionar',
      showResults: 'Mostrar resultados',
      cleanFilters: 'Limpiar filtros'
    },
    freightData: {
      title: 'Información adicional',
      shipmentNumber: 'NUMERO DE EMBARQUES',
      totalInvoiceCost: 'COSTO TOTAL DE FACTURA',
      freightCost: 'COSTOS POR FLETE',
      accesorialCost: 'COSTOS POR ACCESORIOS',
      taxesCost: 'COSTOS POR IMPUESTOS',
      fuelCost: 'COSTO POR COMBUSTIBLE',
      packages: 'BULTOS',
      lbs: 'LIBRAS',
      weigth: 'PESO',
      miles: 'MILLAS',
      value: 'VALOR DECLARADO',
      transitTime: 'Tiempo de tránsito',
      loadHours: 'HORAS AL CARGAR',
      unloadHours: 'HORAS AL DESCARGAR',
      // totalTransitTime: 'TIEMPO TOTAL DE TRáNSITO',
      totalTransitTime: 'Tiempo de tránsito',
      averageTransitTime: 'TIEMPO PROMEDIO DE TRÁNSITO',
      minimumTransitTime: 'TIEMPO MÍNIMO DE TRÁNSITO',
      maximumTransitTime: 'TIEMPO MÁXIMO DE TRANSITO',
      // totalLoadHours: 'HORAS TOTALES DE CARGA',
      totalLoadHours: 'Tiempo de carga',
      averageLoadHours: 'HORAS PROMEDIO DE CARGA',
      minimumLoadHours: 'HORAS MÍNIMAS DE CARGA',
      maximumLoadHours: 'HORAS MÁXIMAS DE CARGA',
      totalUnloadHours: 'Tiempo de descarga',
      averageUnloadHours: 'HORAS PROMEDIO DE DESCARGA',
      minimumUnloadHours: 'HORAS MÍNIMAS DE DESCARGA',
      maximumUnloadHours: 'HORAS MÁXIMAS DE DESCARGA',
      minimumTime: 'Tiempo mínimo',
      maximumTime: 'Tiempo máximo'
    }
  },
  menu: {
    lbl_scan: 'Escanear QR',
    lbl_account: 'Mi cuenta',
    lbl_unit_request: 'Solicitud de Unidad'
  },
  account: {
    lbl_type: 'Tipo de usuario',
    lbl_date: 'Fecha de alta',
    msg_user:
      'Si deseas actualizar tus datos de contacto, es necesario que te comuniques directamente con tu agente de seguimiento',
    btn_pass: 'Cambiar contraseña',
    msg_pass:
      'La contraseña debe tener al menos seis caracteres e incluir una combinación de números y letras mayúsculas.',
    pdr_newpass: 'Contraseña nueva',
    btn_change: 'Cambiar contraseña',
    msg_change_pass: 'Tu contraseña cambió exitosamente.',
    lbl_language: 'Selecciona tu idioma',
    btn_language: 'Cambiar idioma'
  },
  auth: {
    login: {
      forgot_link: 'Olvidé mi contraseña',
      login_btn: 'Iniciar sesión',
      forgot_title: 'Restablecer contraseña',
      forgot_description:
        'Ingresa tu dirección de correo electrónico asociada a tu cuenta y te enviaremos un enlace para restablecer tu contraseña.',
      forgot_input: 'Escribe tu correo electrónico',
      forgot_btn: 'Enviar enlace de contraseña',
      msg_recovery:
        'Hemos enviado con éxito un correo electrónico a tu cuenta para recuperar tu contraseña.'
    }
  },
  home: {
    welcome_back: 'Bienvenido de nuevo',
    lbl_tracking: 'Seguimientos totales de la última semana',
    lbl_requests: 'Solicitudes totales de la última semana',
    title_tracking: 'Últimos seguimientos',
    title_requests: 'Últimas solicitudes',
    list_btn: 'Ver todas'
  },
  request: {
    priority: {
      normal: 'Normal',
      urgent: 'Urgente',
      critical: 'Crítico'
    },
    status: {
      pending: 'Pendiente',
      quoted: 'Cotizada',
      accepted: 'Aceptada',
      refused: 'Rechazada'
    },
    pdr_search: 'Buscar por ID',
    btn_create: 'Crear solicitud',
    filter: {
      title: 'Filtrar por',
      lbl_request: 'Tipo de solicitud',
      lbl_unit: 'Tipo de unidad',
      lbl_priority: 'Nivel de urgencia',
      lbl_date: 'Fecha',
      this_week: 'Esta semana',
      last_week: 'Semana pasada',
      this_month: 'Este mes',
      last_month: 'Mes pasado',
      custom: 'Personalizado',
      btn_result: 'Ver resultados',
      btn_clean: 'Limpiar filtros'
    },
    create: {
      lbl_vehicle: 'Tipo de vehículo',
      lbl_shipper_ref: 'Referencia del remitente',
      lbl_loading_date: 'Fecha de carga',
      lbl_description_goods: 'Descripción de bienes',
      lbl_unit_measurement: 'Unidad de medida',
      lbl_unit_weight_lbs: 'Peso libras',
      opt_domestic_usa: 'DOMÉSTICO EE.UU.',
      pdr_service: 'Tipo de servicio',
      pdr_date: 'Fecha de recolección',
      pdr_zipcode: 'Código postal',
      pdr_address: 'Ingresa la dirección',
      pdr_origin: 'Ciudad de origen',
      pdr_destination: 'Ciudad de destino',
      pdr_state: 'Estado',
      lbl_weight: 'Dimensiones y peso',
      lbl_number: 'Número de bultos',
      btn_create: 'Crear solicitud',
      msg_create: 'La solicitud fue creada exitosamente.'
    },
    detail: {
      lbl_quote: 'Detalle y cotización',
      lbl_update: 'Última actualización',
      btn_add: 'Agregar cotización',
      btn_comment: 'Comentar',
      pdr_comment: 'Escribe tu comentario',
      btn_quote: 'Subir cotización',
      btn_accept: 'Aceptar cotización',
      btn_refuse: 'Rechazar cotización',
      lbl_comment: 'Sin comentarios',
      empty_comment:
        'En esta sección aparecerán los comentarios de esta solicitud, puedes crear un comentario en la parte inferior.',
      msg_quote_add: 'La cotización ha sido agregada satisfactoriamente.',
      msg_notes: 'Tu comentario se creó exitosamente.',
      msg_refuse: 'La cotización fue rechazada.',
      msg_accept: 'La cotización fue aceptada.',
      lbl_origin: 'Origen',
      lbl_destination: 'Destino',
      lbl_intermediatePoint: 'Punto intermedio',
      lbl_endPoint: 'Punto final',
      lbl_cameOut: 'Salió',
      lbl_route: 'Ruta',
      lbl_arrive: 'Llegó',
      lbl_on: 'el',
      lbl_status_inProgress: 'En curso',
      lbl_status_pending: 'Pendiente',
      lbl_status_filled: 'Completado',
      lbl_unit: 'Unidad',
      lbl_lastUpdate: 'Última ubicación',
      lbl_locationShared: 'Ubicación compartida por el chofer',
      lbl_btn_forwardLink: 'Reenviar enlace',
      lbl_btn_call: 'Llamar',
      lbl_btn_assignADriver: 'Asignar chofer y compartir',
      lbl_btn_noDriverAssigned: 'Sin chofer asignado',
      lbl_incompleteInformation: 'Información incompleta',
      status: {
        lbl_group_in_preparation: 'En preparación',
        lbl_invited: 'Invitado',
        lbl_invited_description:
          'Se envió el enlace al chofer, aún no lo abre.',
        lbl_ready: 'Listo para salir',
        lbl_ready_description:
          'El chofer aceptó y comparte ubicación; no ha salido del origen.',
        lbl_group_in_transit: 'En tránsito',
        lbl_en_route: 'En ruta',
        lbl_en_route_description: 'Salió del origen y avanza hacia el destino.',
        lbl_near_dest: 'Cerca del destino',
        lbl_near_dest_description:
          'Entró al radio de llegada del destino (p. ej. 10 km).',
        lbl_group_detained_in_transit: 'Tránsito detenido',
        lbl_break_detected: 'Parada detectada',
        lbl_break_detected_description:
          'El sistema detecta la unidad detenida sin descanso registrado.',
        lbl_on_break: 'En descanso',
        lbl_on_break_description:
          'El chofer registró un descanso; parada esperada.',
        lbl_group_at_destination: 'En destino',
        lbl_at_dest: 'En destino',
        lbl_at_dest_description: 'Llegó a las instalaciones del destino.',
        lbl_at_ramp: 'En rampa',
        lbl_at_ramp_description:
          'Asignado a rampa / andén, esperando descarga.',
        lbl_delivering: 'Entregando',
        lbl_delivering_description: 'Descarga o entrega en proceso.',
        lbl_awaiting_instructions: 'Esperando instrucciones',
        lbl_awaiting_instructions_description:
          'El chofer espera indicación del operador para continuar.',
        lbl_group_closing: 'Cierre',
        lbl_pod_pending: 'POD pendiente',
        lbl_pod_pending_description:
          'Entregado; falta la prueba de entrega (firma / foto).',
        lbl_completed: 'Completada',
        lbl_completed_description:
          'Entregado con POD; se deja de compartir ubicación.'
      }
    }
  },
  devices: {
    msg_device:
      ' Esta es la sección de los dispositivos vinculados, desde aquí podras administrar qué dispositivos tienen acceso a la información del Grupo Proexi, así como editar, eliminar o agregar nuevos dispositivos',
    pdr_search: 'Buscar dispositivos',
    btn_device: 'Conectar nuevo dispositivo',
    msg_code:
      'Para iniciar sesión, confirma que el siguiente código coincida con esta pantalla:',
    msg_qr:
      'Si el código no coincide, presiona "Cancelar" y vuelve a escanear el código QR de tu pantalla.',
    title_edit: 'Editar dispositivo',
    lbl_dark: 'Activar modo oscuro',
    msg_dark:
      'Elige si deseas activar el modo oscuro cuando se visualice la aplicación dentro de las pantallas conectadas',
    msg_remove: 'El dispositivo se eliminó correctamente.',
    title_edit: 'Editar nombre',
    msg_edit: 'Asigna el nombre para identificar a este dispositivo',
    title_delete: 'Eliminar Dispositivo',
    msg_delete:
      '¿Estás seguro de que deseas eliminar este dispositivo? Al hacerlo no podras visualizar la información en tu pantalla, y tendrás que vincular de nuevo la aplicación.',
    btn_delete: 'Eliminar dispositivo',
    msg_device_pair: 'El dispositivo se conectó correctamente.',
    msg_invalid_link: 'El enlace es inválido.',
    title_assign_name: 'Asignar nombre',
    caption_assign_name: 'Asigna un nombre para identificar este dispositivo',
    lbl_device_name: 'Nombre del dispositivo',
    lbl_device_type: 'Tipo de dispositivo',
    lbl_device_location: 'Ubicación del dispositivo'
  },
  tracking: {
    pdr_search: 'Buscar por PLO o ID de cliente',
    lbl_date: 'Fecha de salida',
    lbl_truck: '# de Caja/Camión',
    last_update: 'Última actualización',
    add_notes: 'Agregar observaciones',
    msg_remove: '¿Estás seguro de continuar con esta acción?',
    title_empty_updates: 'Sin actualizaciones de actividad',
    msg_empty_updates:
      'En esta sección aparecerán las actualizaciones para este seguimiento, para crear un nuevo registro de actualización da click en el botón inferior.',
    title_empty_docs: 'Sin documentos',
    msg_empty_docs:
      'En esta sección aparecerán los documentos de este seguimiento.',
    btn_add_doc: 'Agregar documento',
    btn_add_files: 'Agregar archivos',
    msg_loc: 'Por favor permite que la aplicación acceda a tu ubicación.',
    btn_doc: 'Subir documento',
    btn_share: 'Compartir PLO',
    btn_shareRoute: 'Compartir ruta',
    btn_resend_invitation: 'Reenviar invitación',
    btn_share_access: 'Compartir acceso',
    btn_copy_access: 'Copiar acceso',
    msg_notes: 'Tus observaciones han sido agregadas satisfactoriamente',
    msg_remove_notes:
      'Tus observaciones han sido eliminadas satisfactoriamente',
    msg_share_plo1:
      'Te compartimos el acceso para realizar el seguimiento con folio:',
    msg_share_plo2: 'en la siguiente liga:',
    msg_copy_link: 'Se ha copiado el enlace correctamente',
    msg_copy_link_error: 'No ha sido posible compartir el enlace',
    lbl_transit_time: 'Tiempo de tránsito',
    lbl_logistics_operator: 'Operador logístico',
    lbl_phone_number: 'Número de teléfono',
    lbl_copy_share:
      'Ingresa el número telefónico del conductor que llevará a cabo el seguimiento del viaje.',
    btn_send_access: 'Enviar acceso',
    lbl_message_share_route:
      'Te compartimos el acceso para realizar el seguimiento en la siguiente liga:',
    update: {
      title_update: 'Agregar actualización',
      lbl_type: 'Tipo de actualización',
      pdr_detail: 'Detalle de la actualización',
      pdr_notes: 'Notas de la actualización',
      btn_create: 'Crear actualización',
      lbl_photo: 'Subir fotos',
      lbl_doc: 'Subir documentos',
      lbl_audio: 'Grabar audio',
      lbl_audio_2: 'Regrabar audio',
      lbl_record: 'Grabar una nota de voz',
      msg_create: 'La actualización se creó correctamente.'
    }
  },
  notifications: {
    title: 'Sin notificaciones',
    caption:
      'En esta sección aparecerán las notificaciones de actividad, cambio de estatus y solicitudes.'
  },
  errors: {
    err_geolocation_service:
      'El servicio de ubicación está desactivado. Por favor, activa el servicio de ubicación en tu dispositivo para continuar.',
    err_mic: 'Error al acceder al micrófono:',
    err_loc: 'No fue posible obtener tu ubicación.',
    err_default:
      'Sucedió un error desconocido al realizar la petición al servidor.',
    err_503: {
      slam: 'Lo sentimos, la plataforma SLAM tuvo un problema al guardar la actualización.',
      areelec:
        'Lo sentimos, la base de datos AREELEC tuvo un problema al guardar la actualización.'
    },
    err_401: {
      default: 'Debes estar autenticado para poder acceder a este recurso.',
      token:
        'Su sesión ha sido usada en otro dispositivo y ha sido desactivada. Vuelva a iniciar sesión para ingresar nuevamente a la plataforma.',
      credentials: 'Usuario y/o contraseña incorrectos.'
    },
    err_404: {
      default: 'El recurso no fue encontrado en el servidor.',
      order: 'La orden no existe.',
      gps: 'No se cuenta con información GPS.'
    },
    err_422: {
      order: 'Ya cuentas con una orden creada.',
      session: 'El tiempo de registro ha expirado.',
      unauthorized: 'No estás autorizado para realizar esta acción.',
      invalid_session: 'La sesión actual no existe o es inválida.',
      invalid_token:
        'El código no es válido, por favor verifica que tu código sea correcto.',
      invalid_slam_status:
        'Lo sentimos, la plataforma SLAM no cuenta con el estatus proporcionado para actualizar.',
      invalid_areelec_status:
        'Lo sentimos, la base de datos AREELEC no cuenta con el estatus proporcionado para actualizar.',
      invalid_extension_file:
        'Lo sentimos, la extensión del archivo no es valida.',
      100: {
        email: 'El correo electrónico ya se encuentra registrado.'
      }
    }
  },
  rules: {
    required: 'El campo es requerido',
    min: 'El valor debe ser mayor o igual a {min}',
    max: 'El valor debe ser menor o igual a {max}',
    minLength: 'El valor debe tener al menos {min} caracteres',
    maxLength: 'El valor debe tener como máximo {max} caracteres',
    hasSpecialChar: 'El campo debe contener al menos un caracter especial',
    hasUpper: 'El campo debe contener al menos una letra mayúscula',
    hasLower: 'El campo debe contener al menos una letra minúscula',
    hasNumber: 'El campo debe contener al menos un número',
    pattern:
      'La contraseña debe contener una letra mayúscula, una letra minúscula, un dígito y un caracter especial (#?!@$%^&*-) por lo menos.'
  }
}
